import { preguntaTypes } from "../../types/preguntaTypes";
import { preguntaState } from "../../states/preguntaState";

export const preguntaReducer = ( state = preguntaState, action ) => {
    switch ( action.type ) {

		case preguntaTypes.PREGUNTA_GET_START:
            return { ...state, isLoading: true };

		case preguntaTypes.PREGUNTA_GET_COMPLETE:
            return { ...state, isLoading: false, message: 'Se buscó con éxito', severity: 'success', ...action.payload };
 
		case preguntaTypes.PREGUNTA_SET_COMPLETE:
            return { ...state, ...action.payload };

        case preguntaTypes.PREGUNTA_SET_HABILITADO:
            return {
                ...state,
                preguntas: state.preguntas.map(
                    preg => preg.ID === action.payload.ID
                        ? { ...preg , HABILITADO: action.payload.HABILITADO }
                        : preg
                )
            }

        case preguntaTypes.PREGUNTA_SET_UPLOAD:
            return {
                ...state,
                preguntas: state.preguntas.map(
                    preg => preg.ID === action.payload.ID
                        ? { ...preg , 
                            UPLOAD: action.payload.UPLOAD, 
                            CANTIDAD_ARCHIVO: action.payload.CANTIDAD_ARCHIVO, 
                            FORMATO_ARCHIVO: action.payload.FORMATO_ARCHIVO, 
                            OBLIGATORIO_ARCHIVO: action.payload.OBLIGATORIO_ARCHIVO,
                            DROPZONE_TEXT: action.payload.DROPZONE_TEXT }
                        : preg
                )
            }
            
        case preguntaTypes.PREGUNTA_GET_ERROR:
            return { ...state, isLoading: false, 
                grupos: [],
                preguntas: [],
                respuestas: [],
                dependencias: [],
                ...action.payload };

        default:
            return { ...state };
    }
}
